function resolveStreetTypeFromZipCodeLookup(streetType: string | null | undefined, cep: string) {
	const normalizedStreetType = streetType || null;

	if (normalizedStreetType !== null) {
		return normalizedStreetType;
	}

	return cep.endsWith('000') ? 'R' : null;
}

export {resolveStreetTypeFromZipCodeLookup};
